import { useEffect, useRef } from "react";

const INACTIVITY_LIMIT = 30 * 60 * 1000;

export default function useInactivityLogout(onLogout) {
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onLogout?.();
    }, INACTIVITY_LIMIT);
  };

  const activityHandler = () => {
    resetTimer();
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, activityHandler));

    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, activityHandler));
    };
  }, []);
}
